import React, { useState } from "react";
import { Button, Icon, Confirm } from "semantic-ui-react";
import { UsersDB } from "../../../../api";
import "./UsersDBItem.scss";

const usersDb = new UsersDB();

export function UsersDBItem({ user, onView, idClientPadre, reloadUsers }) {
  const [showConfirm, setShowConfirm] = useState(false); // Estado para mostrar el modal de confirmación
  const [confirmMessage, setConfirmMessage] = useState("");
  console.log("Usuario recibido en UsersDBItem:", user);
  //console.log("Usuario recibido en UsersDBItem (_id):", user?._id);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState); // Abrir y cerrar modal de confirmación
  //console.log('idClientPadre:', idClientPadre);
  const openDeleteConfirm = () => {
    setConfirmMessage(
      `¿Estás seguro de que deseas eliminar al usuario ${user.name}?`,
    );
    onOpenCloseConfirm(); // Mostrar el modal de confirmación
  };

  const handleDelete = async () => {
    try {
      //console.log('Eliminando usuario:', user._id);
      //console.log('ID del cliente padre:', idClientPadre);
      await usersDb.deleteUserOfClient(idClientPadre, user._id);
      //console.log('Usuario eliminado:', result);

      // Refrescar la lista de usuarios
      reloadUsers();

      // Cerrar el modal de confirmación
      onOpenCloseConfirm();
    } catch (error) {
      console.error("Error al eliminar el usuario:", error);
    }
  };
  const getSiglaByNumber = (number) => {
    switch (number) {
      case "1":
        return "ULA";
      case "2":
        return "UTC";
      case "3":
        return "UTEG";
      case "4":
        return "UANE";
      case "5":
        return "INDO";
      case "6":
        return "LOTTUS";
      default:
        return "Otros"; // Para cualquier otro número
    }
  };
  const getRamaByNumber = (number) => {
    switch (number) {
      case "1":
        return "BACHILLERATO";
      case "2":
        return "LICENCIATURA";
      case "3":
        return "POSTGRADO";
      default:
        return "Otros"; // Para cualquier otro número
    }
  };
  return (
    <>
      <tr className="userdb-item">
        <td>{user.name || "..."}</td>
        <td>{getSiglaByNumber(user.marca) || "..."}</td>
        <td>{getRamaByNumber(user.rama) || "..."}</td>
        <td>{user.ubication || "..."}</td>
        <td>{user.levels || "..."}</td>
        <td>{user.completados || "..."}</td>
        <td>
          <Button icon primary onClick={() => onView(user)}>
            <Icon name="eye" />
          </Button>
          <Button icon color="red" onClick={openDeleteConfirm}>
            <Icon name="trash" />
          </Button>
        </td>
      </tr>

      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseConfirm} // Para cancelar y cerrar el modal
        onConfirm={handleDelete} // Para confirmar y eliminar
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
